<span
  class="outline-badge outline-badge--{{ resolvedType }}"
  [class.outline-badge--rounded]="rounded"
>
  @if (dot) {
    <span class="outline-badge__dot"></span>
  }
  <span class="outline-badge__label" [title]="label">{{ label }}</span>
</span>
